
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"5.1","stroke":"#00AA6C","stroke-width":"1.8","fill":"none","fill-rule":"evenodd"}})])
          )
        }
      }
    